import PropTypes from 'prop-types';
import React, { memo } from 'react';

import Button from '../../helpers/Button';

const CallTranscriptComponent = ({ callLogUrl, onShowDetailedNotes }) => (
  <div className="row">
    {typeof onShowDetailedNotes === 'function' && (
      <div className="col-xs-6 text-left">
        <Button className="btn-link" onClick={onShowDetailedNotes}>
          Detailed Notes
        </Button>
      </div>
    )}
    {callLogUrl ? (
      <div className={typeof onShowDetailedNotes === 'function' ? 'col-xs-6 text-right' : 'col-xs-12 text-right'}>
        <a
          className="btn btn-link text-right text-decoration-none"
          href={callLogUrl}
          rel="noopener noreferrer"
          target="_blank"
        >
          Call Transcript
        </a>
      </div>
    ) : null}
  </div>
);

CallTranscriptComponent.propTypes = {
  callLogUrl: PropTypes.string,
};

/** Call transcript component. */
export const CallTranscript = memo(CallTranscriptComponent);
